module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-POOL.01dbdb49.jpg";